/* eslint-disable arrow-body-style */
import moment from "moment";
import { dateFormatStr } from "../../_config/dateFormatConfig";
import { BLACK_GAME_LIST, DATA_FRAME_LIST } from "../../_config/constant";

interface SeasonInfo {
  day: never[];
  week: never[];
  month: never[];
}

interface DateValInfo {
  date: never[];
  week: never[];
  month: never[];
}

// 返回页面需要的日期筛选器的数据
const formatSeasonInfo = (seasonInfo: SeasonInfo) => {
  // 后端有变动，现在只返回日粒度数据，要求前端自己转为周月
  const dateVal = seasonInfo?.day || [];
  // const weekVal = seasonInfo?.week || [];
  // const monthVal = seasonInfo?.month || [];
  const seasonInfoResult = {
    date: formatSeasonInfoDate(dateVal, 'date'),
    week: formatSeasonInfoDate(dateVal, 'week'),
    month: formatSeasonInfoDate(dateVal, 'month'),
  };
  return seasonInfoResult;
};

const formatSeasonInfoDate = (dateArr: string[], type: string) => {
  const result = dateArr?.map((item: any) => {
    let items = item;
    if (type === 'date') {
      items = item;
    } else if (type === 'week') {
      items = { 
        ...item,
        start_date: moment(item?.start_date)?.startOf('isoWeek')?.format(dateFormatStr), // 使用ISOweek标准，避免不同地区的周开始时间不一致
        end_date: moment(item?.end_date)?.startOf('isoWeek').endOf('isoWeek')?.format(dateFormatStr)
      };
    } else if (type === 'month') {
      items = {
        ...item,
        start_date: moment(item?.start_date)?.startOf('month')?.format(dateFormatStr),
        end_date: moment(item?.end_date)?.startOf('month').endOf('month')?.format(dateFormatStr)
      };
    }
    return {
      ...items,
      onClick: () => [moment(items?.start_date), moment(items?.end_date)]
    };
  });
  return result;
};

const setDateShortcutOption = (val: DateValInfo, seasonInfo: DateValInfo) => ({
  date: [...(val?.date), ...(seasonInfo?.date)],
  week: [...(val?.week), ...(seasonInfo?.week)],
  month: [...(val?.month), ...(seasonInfo?.month)]
});

// 判断游戏是否应被隐藏
const shouldHideGame = (game: any, parentGameCode?: string) => !game?.is_access && (BLACK_GAME_LIST.includes(game?.game_code) || BLACK_GAME_LIST.includes(parentGameCode));

// 定义一个函数来过滤 main_game 和 game_phase_list
const hideBlackGameList = (games: any[]): any[] => {
  return games?.filter(game => {
    const gameList = game?.game_List || [];
    if (gameList?.length > 0) {
      game.game_List = gameList?.filter((subGame: any) => {
        return !shouldHideGame(subGame, game?.game_code);
      });
      // 按逻辑来说，应该还要判断 || (game.game_List.length === 0 && !shouldHideGame(game)),但实际上当!shouldHideGame(game)为true的时候，
      // game.game_List.length必然大于等于1，因为主版本也在game_List中，主版本如果要展示的话game_list 的长度肯定大于等于1
      return game.game_List?.length > 0;
    }
    return !shouldHideGame(game);
  });
};

const formatGameList = (gameList: any[]) => (gameList?.map((item) => {
  item.rawDataFrame = item.data_frame;
  if (!DATA_FRAME_LIST.includes(item?.data_frame)) {
    item.data_frame = 'mobile';
  }
  if (item?.game_List) {
    item?.game_List?.forEach((game: any) => {
      game.rawDataFrame = game.data_frame;
      if (!DATA_FRAME_LIST?.includes(game?.data_frame)) {
        game.data_frame = 'mobile';
      }
    });
  }
  return item;
}) || []);

export {
  formatSeasonInfo,
  setDateShortcutOption,
  hideBlackGameList,
  formatGameList
};